"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _EDSContext = require("./../EDSContext/EDSContext");
var _CarouselStepper = _interopRequireDefault(require("./internal/CarouselStepper"));
var _Typography = _interopRequireDefault(require("../Typography/Typography"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _reactResponsiveCarousel = require("react-responsive-carousel");
var _styles2 = _interopRequireDefault(require("./styles/styles"));
var _lib = require("@ellucian/ds-icons/lib");
var _tokens = require("../styles/tokens");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["classes", "className", "children", "edsContext", "activeStep", "onChange", "loops", "swipeable", "arrowMode", "fullHeight"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A slideshow component for cycling through elements—images or slides of text—like a carousel.
 * @done true
 * @updated v7.12.0
 * @versionAdded v6.2.0
 * @examples
 * CarouselImage
 * DisabledLooping
 * InteractiveElements
 * LongCarousel
 * FullHeightCarousel
 */

var Carousel = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _cn;
  var classes = props.classes,
    className = props.className,
    children = props.children,
    edsContext = props.edsContext,
    activeStep = props.activeStep,
    onChange = props.onChange,
    loops = props.loops,
    swipeable = props.swipeable,
    arrowMode = props.arrowMode,
    fullHeight = props.fullHeight,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var steps = _react.default.Children.count(children);

  // this is only used to handle the hover
  var _useState = (0, _react.useState)(false),
    showArrows = _useState[0],
    setShowArrows = _useState[1];
  var onHover = function onHover() {
    setShowArrows(true);
  };
  var onLeave = function onLeave() {
    setShowArrows(false);
  };

  // used for mobile to track what type of arrows to show
  var localMode = arrowMode;
  if (edsContext.platform === 'mobile' && arrowMode === 'floating') {
    localMode = 'floatingMobile';
  }

  // index reassignment is to handle looping with Stepper arrows
  // if the requested index is greater than the maximum index of children, then go back to start (0)
  // if the requested index is less than the minimum index of children, then go back to the end (steps - 1)
  var handleActiveStep = function handleActiveStep(index) {
    //top level if is to temporarily prevent re-render. should be removed with EET-5065
    if (index === activeStep) {
      return;
    } else if (index > steps - 1) {
      index = 0;
    } else if (index === -1) {
      index = steps - 1;
    }
    onChange(index);
  };
  var showPrevArrow = function showPrevArrow() {
    // mode is floatingMobile and we're not at the beginning of the carousel, show
    // mode is floating, and we're not at the beginning of the carousel, show
    return (localMode === 'floatingMobile' || localMode === 'floating' && showArrows) && (loops || activeStep > 0);
  };
  var renderPrev = function renderPrev(onClickHandler) {
    return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      onClick: onClickHandler,
      "aria-label": edsContext.formatMessage('component.CarouselStepper.backButton'),
      className: classes.prevArrow
    }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_lib.ChevronRight, {
      width: _tokens.sizingSmall,
      height: _tokens.sizingSmall
    }) : /*#__PURE__*/_react.default.createElement(_lib.ChevronLeft, {
      width: _tokens.sizingSmall,
      height: _tokens.sizingSmall
    }));
  };
  var showNextArrow = function showNextArrow() {
    // mode is floatingMobile and we're not at the end of the carousel, show
    // mode is floating, and we're not at the end of the carousel, show
    return (localMode === 'floatingMobile' || localMode === 'floating' && showArrows) && (loops || activeStep < steps - 1);
  };
  var renderNext = function renderNext(onClickHandler) {
    return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      onClick: onClickHandler,
      "aria-label": edsContext.formatMessage('component.CarouselStepper.nextButton'),
      className: classes.nextArrow
    }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_lib.ChevronLeft, {
      width: _tokens.sizingSmall,
      height: _tokens.sizingSmall
    }) : /*#__PURE__*/_react.default.createElement(_lib.ChevronRight, {
      width: _tokens.sizingSmall,
      height: _tokens.sizingSmall
    }));
  };
  var classOverride = (0, _classnames.default)(className, (_cn = {}, _cn[classes.fullHeight] = fullHeight, _cn));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classOverride,
    onMouseEnter: localMode === 'floating' ? onHover : null,
    onMouseLeave: localMode === 'floating' ? onLeave : null
  }, /*#__PURE__*/_react.default.createElement(_reactResponsiveCarousel.Carousel, (0, _extends2.default)({
    className: classes.root,
    selectedItem: activeStep,
    onChange: function onChange(index) {
      return handleActiveStep(index);
    },
    infiniteLoop: loops,
    showIndicators: false,
    showThumbs: false,
    showArrows: arrowMode === 'floating',
    renderArrowPrev: showPrevArrow() ? renderPrev : undefined,
    renderArrowNext: showNextArrow() ? renderNext : undefined,
    showStatus: false,
    swipeable: swipeable
    // adds vertical tolerance when swiping -- lets the user swipe vertically on the page, without the carousel responding
    ,
    preventMovementUntilSwipeScrollTolerance: true,
    useKeyboardArrows: true,
    ref: ref
  }, rest), children.map(function (child, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'carousel-child',
      key: index,
      "aria-hidden": activeStep === index ? false : true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "srOnly"
    }, "" + edsContext.formatMessage('component.Carousel.stepOfTotal', {
      activeStep: activeStep + 1,
      steps: steps
    })), child);
  })), /*#__PURE__*/_react.default.createElement(_CarouselStepper.default, {
    steps: steps,
    edsContext: edsContext,
    activeStep: activeStep,
    handleActiveStep: handleActiveStep,
    loops: loops,
    mode: arrowMode
  }));
});
Carousel.displayName = 'Carousel';
Carousel.propTypes = {
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * @ignore
   *
   * Classes used to extend original style object.
   */
  classes: _propTypes.default.object,
  /**
   * A CSS class that will be applied to the parent `div`.
   */
  className: _propTypes.default.string,
  /**
   * The slides that appear in the `Carousel`.
   */
  children: _propTypes.default.arrayOf(_propTypes.node).isRequired,
  /**
   * Determines if the `Carousel` should loop.
   */
  loops: _propTypes.default.bool,
  /**
   * The active step of the `Carousel`.
  */
  activeStep: _propTypes.default.number.isRequired,
  /**
   * The function called when the `Carousel` changes activeStep, returns the index of the activeStep
  */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Enable the user to swipe the carousel
   */
  swipeable: _propTypes.default.bool,
  /**
   * Determines where navigation arrows reside.
  */
  arrowMode: _propTypes.default.oneOf(['footer', 'floating']),
  /**
   * Determines if the `Carousel` should expand to the full height of its container. Note: This requires parent container of `Carousel` to have a height specified
   */
  fullHeight: _propTypes.default.bool
};
Carousel.defaultProps = {
  loops: true,
  activeStep: 0,
  swipeable: true,
  arrowMode: 'footer',
  fullHeight: false
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(_styles2.default)(Carousel));